import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useShouldPresentBookingAsLockedRequest } from "../BookingRequest/components/AvailableTeeTimes/hooks/useShouldPresentBookingAsLockedRequest";
import { BookingCharges } from "./BookingCharges";
import { Notifications } from "./Notifications";
import { RequestChargesEstimation } from "./RequestChargesEstimation";
import { ChargesSummary_booking$key } from "./__generated__/ChargesSummary_booking.graphql";

type Props = {
  bookingRef: ChargesSummary_booking$key | null;
  isBookingOwner: boolean;
  showLoyaltyEnrollment?: boolean;
};

export const ChargesSummary = ({
  bookingRef,
  isBookingOwner,
  showLoyaltyEnrollment,
}: Props) => {
  const booking = useFragment(ChargesSummaryFragmentString, bookingRef);
  const isLockedRequest = useShouldPresentBookingAsLockedRequest(
    booking ?? null
  );
  const isQueueBooking =
    booking?.startSlot?.__typename === "QueueSlot" || isLockedRequest;

  return (
    <>
      {isQueueBooking ? (
        <>
          <RequestChargesEstimation bookingRef={booking ?? null} />
          {booking?.startSlot ? (
            <Notifications slotRef={booking?.startSlot} />
          ) : null}
        </>
      ) : (
        <BookingCharges
          bookingRef={booking ?? null}
          isBookingOwner={isBookingOwner}
          showLoyaltyEnrollment={showLoyaltyEnrollment}
        />
      )}
    </>
  );
};
export const ChargesSummaryFragmentString = graphql`
  fragment ChargesSummary_booking on Booking
  @argumentDefinitions(
    patronLoyalty: { type: "Boolean!", defaultValue: false }
  ) {
    startSlot {
      __typename
      ...NotificationsInner_slot
    }
    ...useShouldPresentBookingAsLockedRequest_booking
    ...BookingCharges_booking @arguments(patronLoyalty: $patronLoyalty)
    ...RequestChargesEstimation_booking
  }
`;
